import { LoadPatientPossibleMotherName } from 'domain/usecases/patient/load-patient-possible-mother-name'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteLoadPatientPossibleMotherName
  implements LoadPatientPossibleMotherName
{
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  load(
    params: LoadPatientPossibleMotherName.Params
  ): Promise<LoadPatientPossibleMotherName.Model> {
    return this.patientRepository.loadPatientPossibleMotherName(params)
  }
}
